module.exports = __webpack_public_path__ + "img/miss.5cec42b9.svg";